<template>
  <v-toolbar flat>
    <div
      style="width: 150px" class="mr-2">
      <ejercicio-picker
        v-model="filtros.ejercicio"
        class="mr-2">
      </ejercicio-picker>
    </div>
    <div style="width: 350px" class="mr-2">
      <custom-text-field
        v-model="filtros.buscarTexto"
        label="Buscar..."
        append-icon="mdi-magnify"
        clearable
        @keyup="buscar"
        @click:clear="limpiarBuscadorTexto">
      </custom-text-field>
    </div>
    <filtros
      :contratos="listaContratos"
      :filtros="filtros">
    </filtros>
    <v-spacer></v-spacer>
  </v-toolbar>
</template>

<script>
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';
import EjercicioPicker from '@/components/inputs/EjercicioPicker.vue';
import Filtros from './Filtros.vue';

export default {
  name: 'ToolBarEjecucion',
  props: {
    listaContratos: {
      type: Array,
      required: true,
    },
    filtros: {
      type: Object,
      required: true,
    },
  },
  components: {
    EjercicioPicker,
    Filtros,
    CustomTextField,
  },
  data() {
    return {
      debounce: null,
    };
  },
  methods: {
    buscar(e) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.filtros.buscarTexto = e.target.value;
      }, 600);
    },
    limpiarBuscadorTexto() {
      this.filtros.buscarTexto = '';
    },
  },
};
</script>

<style lang="scss">
</style>
